import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bc918a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col col-error-container info-message icon-finanzierungsbestaetigung-info active"
}
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_base = _resolveComponent("icon-base")!

  return (_ctx.text !== '')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_icon_base, {
          type: "icon",
          name: "information"
        }),
        _createElementVNode("span", { innerHTML: _ctx.text }, null, 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}